/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TaxReturn = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 2.65C17.1639 2.65 21.35 6.83614 21.35 12C21.35 17.1639 17.1639 21.35 12 21.35C6.83614 21.35 2.65 17.1639 2.65 12C2.65 8.60042 4.46432 5.62459 7.17751 3.988L7.12818 6.775H8.77818L8.84896 2.77605V1.12605L7.19896 1.12605L3.2 1.19683V2.84683L5.97119 2.79778C2.9771 4.76334 1 8.15078 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1L12 2.65Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.99326 7.75C7.63963 7.75 6.5 8.85207 6.5 10.2569C6.5 11.648 7.62618 12.75 8.99326 12.75C10.3418 12.75 11.5 11.6804 11.5 10.2569C11.5 8.8501 10.3449 7.75 8.99326 7.75ZM8 10.2569C8 9.68984 8.45868 9.25 8.99326 9.25C9.53791 9.25 10 9.6998 10 10.2569C10 10.8123 9.55364 11.25 8.99326 11.25C8.44508 11.25 8 10.81 8 10.2569Z"
                        fill={color}
                    />
                    <path
                        d="M9.60812 17.4055L7.65179 17.3978L14.5437 7.90222L16.5 7.90995L9.60812 17.4055Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.75 15.0173C12.75 13.6125 13.8896 12.5104 15.2433 12.5104C16.5949 12.5104 17.75 13.6105 17.75 15.0173C17.75 16.4408 16.5918 17.5104 15.2433 17.5104C13.8762 17.5104 12.75 16.4084 12.75 15.0173ZM15.2433 14.0104C14.7087 14.0104 14.25 14.4503 14.25 15.0173C14.25 15.5705 14.6951 16.0104 15.2433 16.0104C15.8036 16.0104 16.25 15.5727 16.25 15.0173C16.25 14.4602 15.7879 14.0104 15.2433 14.0104Z"
                        fill={color}
                    />
                </svg>
        );
    };
